import { useEffect, useRef, useState } from 'react';

const START_SECONDS = 23 * 3600 + 58 * 60 + 42;

type Countdown = {
  hours: string;
  minutes: string;
  seconds: string;
};

function format(total: number): Countdown {
  const safe = Math.max(total, 0);
  return {
    hours: String(Math.floor(safe / 3600)).padStart(2, '0'),
    minutes: String(Math.floor((safe % 3600) / 60)).padStart(2, '0'),
    seconds: String(safe % 60).padStart(2, '0'),
  };
}

export function useCountdown(): Countdown {
  const deadlineRef = useRef<number>(Date.now() + START_SECONDS * 1000);
  const [remaining, setRemaining] = useState(START_SECONDS);

  useEffect(() => {
    const tick = () => {
      setRemaining(Math.round((deadlineRef.current - Date.now()) / 1000));
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);

  return format(remaining);
}
